import axios from "axios";

import Config from "src/config";

// Descoberta dos anuncios que ja geraram lead Click-to-WhatsApp num canal.
// Vem da agregacao dos eventos capturados, nao da Meta: e o unico jeito de
// oferecer uma lista de ad_id sem exigir credencial de Gerenciador de Anuncios.
// params = { canal_id, dias, limit }
const v2_actionAnunciosObservados = (clienteId, params) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/mkt/anuncios/observados`,
        params
    });
};

export default v2_actionAnunciosObservados;
